var _defs, _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew206({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.19,5.58a9.11,9.11,0,0,1,1.36-.1,2.81,2.81,0,0,1,2,.62,2.28,2.28,0,0,1,.7,1.78,2.65,2.65,0,0,1-.71,1.93,3.09,3.09,0,0,1-2.2.71,9.7,9.7,0,0,1-1.16-.06ZM3.83,10a4.1,4.1,0,0,0,.65,0A1.9,1.9,0,0,0,6.59,7.9,1.76,1.76,0,0,0,4.58,6a3.39,3.39,0,0,0-.75.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.09,5.6a7.49,7.49,0,0,1,1.23-.1,2,2,0,0,1,1.39.42,1.32,1.32,0,0,1,.43,1A1.46,1.46,0,0,1,10.76,8a2.07,2.07,0,0,1-1.52.55,2,2,0,0,1-.51-.05v2H8.09ZM8.73,8a2,2,0,0,0,.53,0C10,8,10.5,7.67,10.5,7S10,6,9.33,6a2.64,2.64,0,0,0-.6,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1.08,
    y: 3.65,
    width: 11.98,
    height: 8.71
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 13.07,
    y: 5.82,
    width: 1.85,
    height: 4.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew206);
export default __webpack_public_path__ + "static/media/Symbolpack_New_206.7d7f937a8a55a9aa461092d6931f3e7a.svg";
export { ForwardRef as ReactComponent };